var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 4,
  height: 8,
  viewBox: "0 0 4 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M-1.74846e-07 4L4 0.535898L4 7.4641L-1.74846e-07 4Z",
  fill: "currentColor"
})));
export { SvgArrowBack as ReactComponent };